import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { prefix } from './publicPath';
import Main from './main';
import 'core-js/stable';

import './style';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <Main prefix={prefix} />
    </StrictMode>,
);
